import React, { useState } from "react";
import styled from "styled-components";
import { FiLogOut } from "react-icons/fi"; // Logout icon

// Overlay
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

// Modal container
const ModalContainer = styled.div`
  background: #1f1f1f;
  border-radius: 16px;
  width: 400px;
  max-width: 90%;
  padding: 32px 28px;
  color: #e0e0e0;
  position: relative;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6);
  text-align: center;
`;

// Close button
const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 14px;
  background: transparent;
  border: none;
  color: #bbb;
  font-size: 22px;
  cursor: pointer;
  transition: 0.2s;

  &:hover {
    color: #fff;
  }
`;

// Message text
const Message = styled.p`
  font-size: 18px;
  margin: 20px 0 10px 0;
`;

// Icon wrapper
const IconWrapper = styled.div`
  font-size: 48px;
  color: #a855f7;
  margin-bottom: 30px;
`;

// Buttons wrapper
const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
`;

// Cancel button
const CancelButton = styled.button`
  flex: 1;
  padding: 12px 0;
  border: none;
  border-radius: 12px;
  background: #444;
  color: #fff;
  font-size: 15px;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    background: #666;
  }
`;

// Logout button
const LogoutButton = styled.button`
  flex: 1;
  padding: 12px 0;
  border: none;
  border-radius: 12px;
  background: #a855f7;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    background: #9333ea;
  }
`;

// Loading overlay
const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const Loader = styled.div`
  border: 6px solid #f3f3f3;
  border-top: 6px solid #a855f7;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const LogoutModal = ({ isOpen, onClose, onLogout }) => {
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleLogout = async () => {
    setLoading(true);
    try {
      await onLogout(); // perform logout logic
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
    onClose();
  };

  return (
    <Overlay>
      {loading && (
        <LoadingOverlay>
          <Loader />
        </LoadingOverlay>
      )}
      <ModalContainer>
        <CloseButton onClick={onClose}>&times;</CloseButton>
        <Message>Are you sure you want to logout?</Message>
        <IconWrapper>
          <FiLogOut />
        </IconWrapper>
        <ButtonsWrapper>
          <CancelButton onClick={onClose}>Cancel</CancelButton>
          <LogoutButton onClick={handleLogout}>Logout</LogoutButton>
        </ButtonsWrapper>
      </ModalContainer>
    </Overlay>
  );
};

export default LogoutModal;
